import React from 'react';
import { Helmet } from 'react-helmet';

const propTypes = {};

const defaultProps = {};

function getSrcUrl(hostname) {
    if (hostname.startsWith('staging5')) {
        return 'https://js-cdn.dynatrace.com/jstag/193963f76f6/bf90712fyz/257a7a312ded9e6a_complete.js';
    }

    if (hostname.startsWith('staging3')) {
        return 'https://js-cdn.dynatrace.com/jstag/193963f76f6/bf90712fyz/257a7a312ded9e6a_complete.js';
    }

    if (hostname.startsWith('resources')) {
        return 'https://js-cdn.dynatrace.com/jstag/193ac538cd2/bf43209jyg/48156793b8cead68_complete.js';
    }

    return '';
}
function Dynatrace() {
    const src = getSrcUrl(window?.location?.hostname || '');

    if (src) {
        return (
            <Helmet>
                <script id="dynatrace-script" async type="text/javascript" src={src} crossOrigin="anonymous" />
            </Helmet>
        );
    }

    return null;
}

Dynatrace.propTypes = propTypes;
Dynatrace.defaultProps = defaultProps;

export default Dynatrace;
